import React from "react";

const WhatIs = () => {
  return (
    <div className="pccHeadContentContainer">
      <h2>
        {" "}
        What is Oman <span>PCC</span> Verification?
      </h2>
      <p>
        Oman PCC verification involves obtaining a Police Clearance Certificate
        from the police or a relevant authority in the applicant’s home country
        (India, in this case) and getting it verified for authenticity. This
        verification ensures that the document is recognized and accepted by the
        Omani authorities.
      </p>
    </div>
  );
};

export default WhatIs;
